import { render, staticRenderFns } from "./TimeIntervalForm.vue?vue&type=template&id=6504f272&scoped=true"
import script from "./TimeIntervalForm.vue?vue&type=script&lang=js"
export * from "./TimeIntervalForm.vue?vue&type=script&lang=js"
import style0 from "./TimeIntervalForm.vue?vue&type=style&index=0&id=6504f272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6504f272",
  null
  
)

export default component.exports